module.exports = __webpack_public_path__ + "img/Decepcionado_Corpo_1.607ff452.png";